// SPDX-License-Identifier: AGPL-3.0-or-later

import {createElementHost} from '@app/features/holiday/utils/createElementHost';

export const HOLIDAY_SIDE_PEEK_HOST_SELECTOR = '[data-flx="holiday.holiday-layer.side-peeks-host"]';

const sidePeekHost = createElementHost();

export const setHolidaySidePeekHost = sidePeekHost.set;
export const getHolidaySidePeekHost = sidePeekHost.get;
export const subscribeHolidaySidePeekHost = sidePeekHost.subscribe;

export function setHolidaySidePeekComposerInset(heightPx: number | null): void {
	sidePeekHost.setCssVar('--side-peek-inset-bottom', heightPx);
}

export const HOLIDAY_SIDE_PEEK_REST_ATTR = 'data-side-peek-rest';

export function scheduleHolidaySidePeekRestWindow(
	element: HTMLElement,
	restStartMs: number,
	restEndMs: number,
): () => void {
	const startId = setTimeout(() => {
		element.setAttribute(HOLIDAY_SIDE_PEEK_REST_ATTR, '');
		element.style.zIndex = '6';
	}, restStartMs);
	const endId = setTimeout(() => {
		element.removeAttribute(HOLIDAY_SIDE_PEEK_REST_ATTR);
		element.style.removeProperty('z-index');
	}, restEndMs);
	return () => {
		clearTimeout(startId);
		clearTimeout(endId);
		element.removeAttribute(HOLIDAY_SIDE_PEEK_REST_ATTR);
		element.style.removeProperty('z-index');
	};
}
